import React, { useState } from "react";
import InfoIcon from "../../../assets/InfoIcon";
import List from "../../../common/ui/List";

interface RenderLabelProps {
  label: string;
  required?: boolean;
  className?: string;
  labelInfo?: {
    title: string;
    list?: string[];
  };
}

const RenderLabel: React.FC<RenderLabelProps> = ({ label, required = false, className = "", labelInfo }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="flex items-center gap-0.5">
      <label className={`text-xs font-normal text-text-label select-none ${className}`} htmlFor={label}>
        {label}
        {required && <span className="text-text-error px-0.5">*</span>}
      </label>
      {labelInfo && (
        <div className="relative ">
          <button
            className="focus:outline-none flex items-center justify-start h-full "
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
            aria-label="More information"
            onClick={(e) => e.preventDefault()}
          >
            <InfoIcon />
          </button>
          {showTooltip && (
            <div
              className="absolute bottom-full -left-4 z-20 mb-2 whitespace-normal rounded bg-brand-darkBlue py-2 px-4 font-medium shadow-lg w-[250px] h-fit flex flex-col"
              role="tooltip"
            >
              <span className="absolute -bottom-1 left-6 -z-10 h-2 w-2 -translate-x-1/2 rotate-45 bg-brand-darkBlue border-r border-b border-brand-dabg-brand-darkBlue"></span>
              <p className={`flex-grow !leading-normal text-xs text-white ${labelInfo?.list ? "font-bold" : " font-normal"}`}>{labelInfo?.title}</p>
              {labelInfo?.list && (
                <List items={labelInfo?.list} variant="bullet" className="py-2 !pl-3" itemClassName="!font-formal !leading-normal text-xs text-white" />
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default RenderLabel;
